module.exports = __webpack_public_path__ + "static/img/joinus.e2019e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/joinus.jpg
// module id = 288
// module chunks = 2